import React, { useState } from "react";
import { Button, Icon, Confirm, Popup, Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { BasicModal } from "../../../Shared";
import { AcademicCycle } from "../../../../api";
import { useAuth, usePermissions } from "../../../../hooks";
import { AcademicCycleForm } from "../AcademicCycleForm";
import { AssignTeacherForm } from "../AssignTeacherForm";
import { ListAcademicPeriod } from "../../AcademicPeriod";
import "./AcademicCycleItem.scss";
import moment from "moment";

const academicCycleController = new AcademicCycle();

export function AcademicCycleItem(props) {
  const { academicCycle, onReload } = props;
  const { accessToken } = useAuth();
  const { hasPermission } = usePermissions();

  const canUpdate = hasPermission("academicCycle", "update");
  const canDelete = hasPermission("academicCycle", "delete");
  const canReadStudents = hasPermission("student", "read");
  const canReadGrades = hasPermission("grade", "read");

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showModalTeacher, setShowModalTeacher] = useState(false);
  const [titleModalTeacher, setTitleModalTeacher] = useState("");

  const [showModalPeriods, setShowModalPeriods] = useState(false);
  const [reloadPeriods, setReloadPeriods] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const [showStartConfirm, setShowStartConfirm] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseModalTeacher = () =>
    setShowModalTeacher((prevState) => !prevState);
  const onOpenCloseModalPeriods = () =>
    setShowModalPeriods((prevState) => !prevState);
  const onReloadPeriods = () => setReloadPeriods((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
  const onOpenCloseStartConfirm = () => setShowStartConfirm((prev) => !prev);

  const openAssignTeacher = () => {
    setTitleModalTeacher(`Asignar docentes en ciclo ${academicCycle.Level.name} ${academicCycle.name}`);
    onOpenCloseModalTeacher();
  };

  const openUpdateAcademicCycle = () => {
    setTitleModal(`Actualizar ciclo académico: ${academicCycle.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar el ciclo académico ${academicCycle.name}?`);
    onOpenCloseConfirm();
  };

  const onStartCycle = async () => {
    try {
      await academicCycleController.startAcademicCycle(academicCycle.id);
      onReload();
      onOpenCloseStartConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const onDelete = async () => {
    try {
      await academicCycleController.deleteAcademicCycle(academicCycle.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const getColor = (status) => {
    switch (status) {
      case 1:
        return "blue"; // Color para Preinscripción
      case 2:
        return "green"; // Color para Iniciado
      case 3:
        return "red"; // Color para Finalizado
      default:
        return "gray"; // Color por defecto
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "PREINSCRIPCIÓN";
      case 2:
        return "INICIADO";
      case 3:
        return "FINALIZADO";
      default:
        return "DESCONOCIDO";
    }
  };

  return (
    <>
      <div className="academic-cycle-item">
        <div className="academic-cycle-item__info">
          <span className="academic-cycle-item__info-title">
            {academicCycle.Level.name} - {academicCycle.name}
          </span>
          <span className="academic-cycle-item__info-start-date">
            <b>Fecha de inicio:</b>{" "}
            {moment.utc(academicCycle.startDate).format("DD/MM/YYYY")}
          </span>
          <span className="academic-cycle-item__info-end-date">
            <b>Fecha de fin:</b>{" "}
            {moment.utc(academicCycle.endDate).format("DD/MM/YYYY")}
          </span>
        </div>
        <div className="academic-cycle-item__actions">
          <Label
            className="academic-cycle-item__info-status"
            color={getColor(academicCycle.status)}
          >
            {getStatusText(academicCycle.status)}
          </Label>
          {canReadStudents && (
            <Popup
              content="Gestionar alumnos"
              trigger={
                <Button
                  icon
                  color="green"
                  as={Link}
                  to={`/admin/academicCycle/${academicCycle.id}/students`}
                >
                  <Icon name="users" />
                </Button>
              }
            />
          )}
          <Popup
            content="Gestión académica"
            trigger={
              <Button
                icon
                color="orange"
                as={Link}
                to={`/admin/academicCycle/${academicCycle.id}/academicManagement`}
              >
                <Icon name="line chart" />
              </Button>
            }
          />
          {canReadGrades && (
            <Popup
              content="Registro de notas literales"
              trigger={
                <Button
                  icon
                  color="olive"
                  as={Link}
                  to={`/admin/academicCycle/${academicCycle.id}/grades`}
                >
                  <Icon name="clipboard list" />
                </Button>
              }
            />
          )}
          <Popup
            content="Horarios de clases"
            trigger={
              <Button
                icon
                color="purple"
                as={Link}
                to={`/admin/academicCycle/${academicCycle.id}/classSchedules`}
              >
                <Icon name="calendar" />
              </Button>
            }
          />
          {canUpdate && (
            <Popup
              content="Períodos académicos"
              trigger={
                <Button icon color="brown" onClick={onOpenCloseModalPeriods}>
                  <Icon name="clock outline" />
                </Button>
              }
            />
          )}
          {canUpdate && (
            <Popup
              content="Asignar docentes"
              trigger={
                <Button icon color="teal" onClick={openAssignTeacher}>
                  <Icon name="users" />
                </Button>
              }
            />
          )}
          {canUpdate && academicCycle.status === 1 && (
            <Popup
              content="Iniciar año académico"
              trigger={
                <Button icon color="green" onClick={onOpenCloseStartConfirm}>
                  <Icon name="play" />
                </Button>
              }
            />
          )}
          {canUpdate && (
            <Popup
              content="Actualizar Año académico"
              trigger={
                <Button icon primary onClick={openUpdateAcademicCycle}>
                  <Icon name="pencil" />
                </Button>
              }
            />
          )}
          {canDelete && (
            <Popup
              content="Eliminar Año académico"
              trigger={
                <Button icon color="red" onClick={openDeleteConfirm}>
                  <Icon name="trash" />
                </Button>
              }
            />
          )}
        </div>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        size="small"
        title={titleModal}
      >
        <AcademicCycleForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          academicCycle={academicCycle}
        />
      </BasicModal>
      <BasicModal
        show={showModalTeacher}
        size="large"
        scrolling={false}
        close={onOpenCloseModalTeacher}
        title={titleModalTeacher}
      >
        <AssignTeacherForm
          onClose={onOpenCloseModal}
          academicCycle={academicCycle}
        />
      </BasicModal>
      <BasicModal
        show={showModalPeriods}
        size="large"
        close={onOpenCloseModalPeriods}
        title={`Períodos académicos - ${academicCycle.Level.name} ${academicCycle.name}`}
      >
        <ListAcademicPeriod
          academicCycleId={academicCycle.id}
          reload={reloadPeriods}
          onReload={onReloadPeriods}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showStartConfirm}
        onCancel={onOpenCloseStartConfirm}
        onConfirm={onStartCycle}
        content={`¿Iniciar el año académico ${academicCycle.name}? El estado cambiará de PREINSCRIPCIÓN a INICIADO.`}
        size="mini"
      />
    </>
  );
}
